import { useAppDispatch, useAppSelector } from './redux';
import { 
  loginUser, 
  logoutUser, 
  clearError, 
  clearAuth
} from '@/store/slices/authSlice';
import { LoginCredentials } from '@/types/auth';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const authState = useAppSelector(state => state.auth);
  const { user, isAuthenticated, isLoading, error } = authState;


  const login = async (credentials: LoginCredentials) => {
    return dispatch(loginUser(credentials));
  };

  const logout = async () => {
    return dispatch(logoutUser());
  };

  const clearAuthError = () => {
    dispatch(clearError());
  };

  const clearAuthState = () => {
    dispatch(clearAuth());
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    clearError: clearAuthError,
    clearAuth: clearAuthState,
  };
};